import { InputHTMLAttributes } from 'react';

type RadioButtonProps = {
  label: string;
} & InputHTMLAttributes<HTMLInputElement>;

export const RadioButton = ({ label, ...rest }: RadioButtonProps) => {
  return (
    <div className="tw-flex tw-items-center tw-gap-2 tw-text-[#001E64]">
      <input
        type="radio"
        className="tw-h-4 tw-w-4 tw-accent-[#001E64]"
        {...rest}
      />
      <span>{label}</span>
    </div>
  );
};
